import React from 'react';
import { RowCell, RowCellTooltip } from '../RowCell';

export interface ILessonCompletionCellProps {
  weekIndex: number;
  numCompletions: number;
  currentWeekIndex: number;
  prescriptionIsNotStarted: boolean;
}

const LessonCompletionCell = (props: ILessonCompletionCellProps) => {
  const {
    weekIndex,
    currentWeekIndex,
    numCompletions,
    prescriptionIsNotStarted,
  } = props;
  const isFutureWeek = weekIndex > currentWeekIndex;
  const danger = numCompletions < 4;
  const isPrecedingWeek = weekIndex === currentWeekIndex - 1;
  const isPastWeek = weekIndex < currentWeekIndex;
  const isCurrentWeek = weekIndex === currentWeekIndex;

  if (isFutureWeek || prescriptionIsNotStarted) {
    return <RowCell>-</RowCell>;
  }
  if (danger && isPrecedingWeek) {
    return (
      <RowCellTooltip
        type="danger"
        tooltipText="Patient has not completed 4 lessons"
      >
        {numCompletions}
      </RowCellTooltip>
    );
  }
  if (danger && isPastWeek) {
    return (
      <RowCellTooltip
        type="warning"
        tooltipText="Patient has not completed 4 lessons"
      >
        {numCompletions}
      </RowCellTooltip>
    );
  }
  if (isCurrentWeek) {
    return (
      <RowCellTooltip tooltipText="Starred value indicates a partial week">
        {numCompletions}
        <sup>*</sup>
      </RowCellTooltip>
    );
  }

  return <RowCell>{numCompletions}</RowCell>;
};

export default LessonCompletionCell;
